import axios from 'axios';
import { apiCucaIncidentBff } from '../config/paths';

export const callUploadFiles = async ({ files, ticketId, functionName }) => {
  try {
    const form = new FormData();
    form.append('ticketId', ticketId);
    files.forEach((file) => {
      form.append('images', file);
    });

    form.append('fromEndpoint', functionName);

    const config = {
      method: 'post',
      url: `${apiCucaIncidentBff}/ticket/guest/images/upload`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: form,
    };
    const response = await axios(config);
    return response;
  } catch (error) {
    throw new Error(`Error en callUploadFiles: ${error.message}`);
  }
};
